import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreLibModule } from 'core-lib';
import { ColorCircleModule } from 'ngx-color/circle';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { FileUploadModule } from 'primeng/fileupload';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { CategoryManagerComponent } from './manages-categories/manages-categories.component';
import { MediaLibraryLibComponent } from './media-library-lib.component';
import { MediaUploadComponent } from './media-upload/media-upload.component';
import {VideojsplayerModule} from "./videojsplayer/videojsplayer.module";
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';



@NgModule({
  declarations: [
    MediaLibraryLibComponent,
    MediaUploadComponent,
    CategoryManagerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    FileUploadModule,
    InputTextModule,
    SelectButtonModule,
    MessageModule,
    ToastModule,
    ConfirmDialogModule,
    ProgressBarModule,
    CoreLibModule,
    TooltipModule,
    DialogModule,
    ColorCircleModule,
    InputSwitchModule,
    SelectModule,
    TagModule,
    CheckboxModule,
    VideojsplayerModule,
    IconFieldModule,
    InputIconModule
  ],
  exports: [
    MediaLibraryLibComponent,
    MediaUploadComponent,
  ],
  providers: [

  ]
})
export class MediaLibraryLibModule { }
